import { Link } from "react-router-dom";

const services = [
  { label: "Asphalt Paving", href: "/services/asphalt-paving" },
  { label: "Asphalt Repair", href: "/services/asphalt-paving" },
  { label: "Sealcoating", href: "/services/asphalt-paving" },
  { label: "Concrete Installation", href: "/services/asphalt-paving" },
  { label: "Concrete Repair", href: "/services/asphalt-paving" },
  { label: "Parking Lot Services", href: "/services/asphalt-paving" },
];

const company = [
  { label: "About Us", href: "/about" },
  { label: "Our Process", href: "/about" },
  { label: "Service Areas", href: "/locations" },
  { label: "Get Estimate", href: "/" },
];

export default function Footer() {
  return (
    <footer className="bg-[#080808] border-t border-asphalt-700">
      <div className="max-w-7xl mx-auto px-6 lg:px-14 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
          {/* Column 1 — Brand */}
          <div>
            <Link to="/" className="inline-block cursor-pointer mb-6">
              <img
                src="https://storage.readdy-site.link/project_files/0119a1ee-e75d-405d-8b2a-d8ea08bbcc66/87302b8c-fb17-43ac-87c3-6be8795b2515_logo2.png?v=3c94924276f61998b62260eea2137fb0"
                alt="Premier Asphalt & Concrete"
                className="h-16 w-auto object-contain"
              />
            </Link>
            <p className="font-body text-asphalt-400 text-sm leading-relaxed mb-8">
              Licensed, insured, and built to last. Serving Colorado with professional asphalt and concrete solutions since 2012.
            </p>
            <div className="flex items-center gap-3">
              {[
                { icon: "ri-facebook-fill", href: "https://www.facebook.com/PremierAsphaltConcrete/" },
                { icon: "ri-instagram-line", href: "https://www.instagram.com/premierasphaltconcrete/" },
                { icon: "ri-youtube-line", href: "https://www.youtube.com/@premierasphaltconcreteinc" },
                { icon: "ri-linkedin-fill", href: "https://www.linkedin.com/company/premier-asphalt-concrete-solutions/" },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center border border-asphalt-600 text-asphalt-400 hover:border-safety-500 hover:text-safety-500 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Column 2 — Services */}
          <div>
            <h4 className="font-heading text-safety-500 text-xl tracking-widest mb-6">
              <a>SERVICES</a>
            </h4>
            <ul className="flex flex-col gap-3">
              {services.map((s) => (
                <li key={s.label}>
                  <Link
                    to={s.href}
                    className="font-body text-asphalt-400 text-sm hover:text-white transition-colors cursor-pointer flex items-center gap-2 group"
                  >
                    <span className="w-3 h-px bg-asphalt-600 group-hover:bg-safety-500 transition-colors" />
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 — Company */}
          <div>
            <h4 className="font-heading text-safety-500 text-xl tracking-widest mb-6">
              <a>COMPANY</a>
            </h4>
            <ul className="flex flex-col gap-3">
              {company.map((c) => (
                <li key={c.label}>
                  <Link
                    to={c.href}
                    className="font-body text-asphalt-400 text-sm hover:text-white transition-colors cursor-pointer flex items-center gap-2 group"
                  >
                    <span className="w-3 h-px bg-asphalt-600 group-hover:bg-safety-500 transition-colors" />
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4 — Contact */}
          <div>
            <h4 className="font-heading text-safety-500 text-xl tracking-widest mb-6">
              <a>CONTACT</a>
            </h4>
            <div className="flex flex-col gap-5">
              <a
                href="tel:+13039971315"
                className="font-heading text-white text-3xl tracking-widest hover:text-safety-500 transition-colors cursor-pointer"
              >
                (303) 997-1315
              </a>
              <a
                href="mailto:Info@PremierAsphaltConcrete.com"
                className="font-body text-asphalt-400 text-sm hover:text-safety-500 transition-colors cursor-pointer"
              >
                Info@PremierAsphaltConcrete.com
              </a>
              <p className="font-body text-asphalt-400 text-sm leading-relaxed">
                9975 Wadsworth Pkwy, Unit K2-150<br />
                Westminster, CO 80021
              </p>
              <div className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 bg-green-500 rounded-full" />
                <span className="font-body text-asphalt-400 text-xs">Mon–Fri 7am–6pm &bull; Sat 8am–4pm</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer bottom */}
      <div className="border-t border-asphalt-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-14 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="font-body text-asphalt-600 text-xs">
            &copy; 2026 Premier Asphalt &amp; Concrete. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="font-body text-asphalt-600 text-xs hover:text-asphalt-300 transition-colors cursor-pointer" rel="nofollow">Privacy Policy</a>
            <a href="#" className="font-body text-asphalt-600 text-xs hover:text-asphalt-300 transition-colors cursor-pointer" rel="nofollow">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
